// removed by extract-text-webpack-plugin
module.exports = {"SlateEditor":"_1xmbnvc7mi","readOnly":"_1mLn5ATN2L","toolbar":"_1P33jmgMwd","focused":"_1VjyRDdUE-","editorWrapper":"_29N7ge3WWn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SlateEditor/SlateEditor.scss
// module id = 371
// module chunks = 0